import { WidgetColumn } from "@bryntum/grid-thin";

export class JobJumpColumn extends WidgetColumn {
  static get type() {
    return "jobJump";
  }

  // @ts-ignore - Bryntum 7.x declares widgets as a property, but we need to override as accessor
  override get widgets() {
    return [
      {
        type: "button",
        text: "Job",
        icon: "b-fa b-fa-link",
        color: "blue",
        cls: "b-raised",
        onAction: ({ source: btn }) => {
          console.log("default job jump widget firing");
          // @ts-ignore
          this.grid.trigger("jobJump", {
            type: "jobJump",
            record: btn.cellInfo.record
          });
        }
      }
    ];
  }
}
